import type { Theme } from '../../themes/themes';

export const createLinkTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: 'smooth',
        },
        body: {
          scrollBehavior: 'smooth',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          display: 'inline',
          textDecoration: 'none',

          '&> svg': {
            fontSize: 'inherit',
            verticalAlign: 'text-bottom',
          },
          '.if6 &': {
            color: theme.palette.text.link,
          },
        },
      },
    },
  },
});
